import React, {Component} from 'react'
import {Editor} from 'react-draft-wysiwyg'
import {connect} from 'react-redux'
import {convertDate, convertDateEng} from '../../../Utils'
import IntlMessages from '../../../Utils/IntlMessages'
import {Button, Form} from 'react-bootstrap'
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css'

let initContentState = null

class CommonAnnouncementCard extends Component {
    constructor(props) {
        super(props)

        if (props.detail) {
            try {
                // console.log('TEXT', props.subject.announce_message_th)
                // console.log('JSON', JSON.parse(props.detail))
                initContentState = JSON.parse(props.detail)
                // console.log("init content ", initContentState)
            } catch (e) {
                // console.log('initContentState error', e)
            }
        }

        this.state = {
            contentState: null,
            initialContentState: initContentState,
            title: this.props.announcement.announce_subject_th,
            linkExt: this.props.announcement.link_ext,


            //ตัวแก้ พิเศษ
            show: true
        }
    }

    componentDidMount(prevProps, prevState) {

        // console.log("xxxxxx", this.props.detail)
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.detail != this.props.detail) {
            this.setState({
                // contentState: JSON.parse(this.props.detail)
                initialContentState: JSON.parse(this.props.detail),
                show: false
            })
        }

        if (this.state.show == false) {
            this.setState({
                show: true
            })
        }
    }

    onTitleChange = event => {
        let title = event.target.value
        this.setState({title})
    }

    onUrlChange = event => {
        let linkExt = event.target.value
        this.setState({linkExt})
    }

    onContentStateChange = contentState => {
        this.setState({contentState})
    }

    onClickSave = () => {
        let {announcement, onSave} = this.props
        let {contentState, initialContentState, title, linkExt} = this.state
        let params = {
            announceId: announcement.announce_id,
            announceCode: announcement.announce_code,
            sectionId: announcement.section_id,
            content: JSON.stringify(contentState || initialContentState),
            title,
            linkExt,
        }
        onSave(params)
    }

    confirmDelete = (announce) => {
        this.props.onDelete(announce)
    }

    goToURL = url => {
        // const link = document.createElement('a')
        // link.href = url
        // link.setAttribute('target', '_blank')
        // document.body.appendChild(link)
        // link.click()
        // link.parentNode.removeChild(link)
        if (!String(url).includes('http')) {
            url = `https://${url}`
        }
        const newWindow = window.open(url, '_blank', 'noopener,noreferrer')
        if (newWindow) newWindow.opener = null

        console.log("goToUrl", url)
    }

    renderDetail = () => {
        try {
            let {initialContentState, contentState} = this.state
            const {canDelete} = this.props

            return (
                <>
                    {
                        //ตัวแก้พิเศษ สำหรับ component ตัวห่วยๆ นี่ -*-
                        this.state.show ? <Editor
                            toolbarHidden={!canDelete}
                            readOnly={!canDelete}
                            wrapperClassName={canDelete ? 'demo-wrapper' : 'wrapper-class'}
                            editorClassName={canDelete ? 'editer-content edit-container' : 'editor-class'}
                            toolbarClassName="toolbar-class"
                            initialContentState={initialContentState}
                            onContentStateChange={this.onContentStateChange}
                            editorContent={contentState}
                        /> : null
                    }
                </>
            )
        } catch (err) {
            return null
        }
    }

    renderLoginStyle() {
        const {mark, detail, announceDate, announceBy, announcement, canDelete} = this.props
        let {title, linkExt} = this.state

        return (
            <div className={`ann-box ann-box-login`}>
                <div className="ann-title ann-title-login">
                    <h2>{announcement?.announce_subject_th}</h2>
                    {canDelete &&
                        <div className="d-inline-block clearfix float-right">
                            <Button variant="danger" onClick={() => this.props.onDelete(announcement.announce_id)}>
                                <i className="ion ion-md-trash mr-2"/>
                                <span>ลบ</span>
                            </Button>
                        </div>
                    }
                </div>
                <div className="ann-title-login mt-2">
                    {this.props.mobileView ?
                        <>
                            <img src={`${process.env.PUBLIC_URL}/img/clock.png`} style={{width: '1rem', height: '1rem'}}
                                 alt=""/> &nbsp;
                        </>
                        :
                        <>
                            <img src={`${process.env.PUBLIC_URL}/img/clock-white.png`}
                                 style={{width: '1rem', height: '1rem'}} alt=""/> &nbsp;
                        </>
                    }
                    <span style={styles.dateTimeText} className="ann-date-time--login">
            <IntlMessages id="COMMON__ANNOUNCED_ON"/>
                        &nbsp;
                        {this.props.setting.locale === 'th-TH'
                            ? convertDate(announceDate, 'วันdddd, D MMMM YYYY เวลา HH:mm น.')
                            : convertDateEng(announceDate, 'dddd, MMMM D, YYYY hh:mm A')}
          </span>
                </div>
                <div className="ann-subject-contor--login">
                    {this.renderDetail()}
                </div>
                {linkExt && (
                    <div className="">
                        <button
                            type="button"
                            className="btn btn-outline-primary btn-xs rounded-pill button-view-more"
                            onClick={() => this.goToURL(linkExt)}
                        >
                            <IntlMessages id="COMMON__VIEW_DETAIL"/>
                        </button>
                    </div>
                )}

            </div>
        )
    }

    renderClassicStyle() {
        const {mark, detail, announceDate, announceBy, announcement, canDelete, onDelete} = this.props
        let {title, linkExt, initialContentState, contentState} = this.state
        return (
            <div className={`ann-box ann-green`}>
                <div className="ann-title">
                    {!canDelete && <b className="d-inline-block">{announcement?.announce_subject_th}</b>}
                    {canDelete &&
                        <>
                            <Form.Group>
                                <Form.Label>
                                    <span style={{fontWeight: 600, fontSize: '0.8rem'}}>หัวข้อประกาศ</span>
                                </Form.Label>
                                <Form.Control as="input" placeholder="หัวข้อประกาศ" value={title}
                                              onChange={this.onTitleChange}/>
                            </Form.Group>
                            <Form.Group>
                                <Form.Label>
                                    <span style={{fontWeight: 600, fontSize: '0.8rem'}}>แนบ URL เพื่อดูรายละเอียดเพิ่มเติม</span>
                                </Form.Label>
                                <Form.Control as="input" placeholder="https://www...." value={linkExt}
                                              onChange={this.onUrlChange}/>
                            </Form.Group>
                        </>
                    }
                </div>
                <div className="mb-2">
                    <img src={`${process.env.PUBLIC_URL}/img/clock.png`} style={{width: '1rem', height: '1rem'}}
                         alt=""/> &nbsp;
                    <span style={styles.dateTimeText}>
            <IntlMessages id="COMMON__ANNOUNCED_ON"/>
                        &nbsp;
                        {this.props.setting.locale === 'th-TH'
                            ? convertDate(announceDate, 'วันdddd, D MMMM YYYY เวลา HH:mm น.')
                            : convertDateEng(announceDate, 'dddd, MMMM D, YYYY hh:mm A')}
          </span>
                </div>
                <div className="ann-subject-contor">{this.renderDetail()}</div>
                {!canDelete && announcement?.link_ext && (
                    <div className="">
                        <button
                            type="button"
                            className="btn btn-outline-primary btn-xs rounded-pill button-view-more"
                            onClick={() => this.goToURL(announcement.link_ext)}
                        >
                            <IntlMessages id="COMMON__VIEW_DETAIL"/>
                        </button>
                    </div>
                )}
                {canDelete &&
                    <div className="d-flex justify-content-end pt-2">
                        <Button variant="success"
                                onClick={this.onClickSave}
                                className="mr-2"
                        >
                            <i className="ion ion-ios-save mr-2"/>
                            <span>บันทึก</span>
                        </Button>
                        <Button variant="danger" onClick={() => onDelete(announcement)}>
                            <i className="ion ion-md-trash mr-2"/>
                            <span>ลบ</span>
                        </Button>
                    </div>
                }
            </div>
        )
    }

    render() {
        return this.props.useLoginStyle ? this.renderLoginStyle() : this.renderClassicStyle()
    }
}

export default connect(
    store => ({
        user: store.authen.user,
        setting: store.theme,
    }),
    null,
)(CommonAnnouncementCard)

const styles = {
    dateTimeText: {
        fontSize: '0.875rem',
    },
}
